import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './MobilePagination.module.scss';

interface MobilePaginationProps {
  pageIndex: number;
  pageCount: number;
  canPreviousPage: boolean;
  canNextPage: boolean;
  gotoPage: (page: number) => void;
  previousPage: () => void;
  nextPage: () => void;
  totalItems: number;
  pageSize: number;
}

export const MobilePagination: React.FC<MobilePaginationProps> = ({
  pageIndex,
  pageCount,
  canPreviousPage,
  canNextPage,
  previousPage,
  nextPage,
  totalItems,
  pageSize,
}) => {
  if (pageCount <= 1) {
    return null;
  }

  const startItem = pageIndex * pageSize + 1;
  const endItem = Math.min((pageIndex + 1) * pageSize, totalItems);

  return (
    <div className={styles.container}>
      <div className={styles.info}>
        <FormattedMessage
          id="pagination.mobile.showing"
          defaultMessage="{start}-{end} of {total}"
          values={{
            start: startItem,
            end: endItem,
            total: totalItems,
          }}
        />
      </div>
      <div className={styles.buttons}>
        <button
          className={styles.button}
          onClick={previousPage}
          disabled={!canPreviousPage}
          aria-label="Previous page"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <span className={styles.pageInfo}>
          {pageIndex + 1} / {pageCount}
        </span>
        <button
          className={styles.button}
          onClick={nextPage}
          disabled={!canNextPage}
          aria-label="Next page"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>
    </div>
  );
};
